"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders a checkmark SVG icon.
 * @param {boolean} completed - Indicates whether the checkmark is completed or not, when completed checkmark is white, otherwise blue.
 * @returns {JSX.Element} - The rendered checkmark SVG icon.
 */
const CheckmarkSVG = ({ completed }) => (react_1.default.createElement("svg", { width: "14", height: "12", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M11.7528 3.52157L5.37622 9.89816C5.28245 10.0154 5.14179 10.0623 5.00113 10.0623C4.83702 10.0623 4.69636 10.0154 4.60259 9.89816L1.22674 6.52232C0.992311 6.31133 0.992311 5.95968 1.22674 5.74869C1.43773 5.51425 1.78938 5.51425 2.00038 5.74869L5.00113 8.72599L10.9792 2.74794C11.1902 2.5135 11.5418 2.5135 11.7528 2.74794C11.9872 2.95893 11.9872 3.31058 11.7528 3.52157Z", fill: completed ? '#FFFFFF' : '#007EFF' })));
exports.default = CheckmarkSVG;
